<template lang="pug">
.alert.alert-info.alert-dismissible(v-if="show")
  button.close(type='button', @click="close") ×
  div
    i.icon.fas.fa-spinner.fa-spin
    | {{msg}}
</template>

<script>
import Vue from 'vue'

export default {
  data(){
    return {
      show: false
    }
  },
  props: {
    msg: String
  },
  methods: {
    close(){
      this.show = false
    },
  },
  async mounted(){
    await Vue.nextTick()
    this.show = true
  },
}
</script>
<style lang="scss" scoped>
</style>
